<!-- <p *ngIf="notification">*{{notification}}</p> -->
<div class="position-relative">
  <!-- <a href="javascript:void(0)" 
     class="position-absolute record__block__circlebtn record__block__circlebtn--normal"
     [class.active]="listening" 
     *ngIf="speechSupported" 
     (click)="startListening($event)" 
     style="right: 2px; top: 2px;">
     <i class="icon-record-audio"></i>
  </a> -->
  <textarea #textBox 
            [(ngModel)]="answer" 
            class="new-options--input large pr-5" 
            [class.large]="_element.wordLimit>100"
            [class.medium]="_element.wordLimit>50 && _element.wordLimit<=100 " 
            [class.small]="_element.wordLimit<=50" 
            cols="3"
            rows="5" 
            [placeholder]="placeholder">
  </textarea>
</div>